<template>
  <section class="print">
    <h3 class="print-color subtitle-border mb-2">{{ $t('report_preview.findings') }}:</h3>
    <!-- 增加胃鏡搭配finding 示意圖 -->
    <div class="align-center highlight-area">
      <div v-if="gastroFindings" align="center" class="pos-relative">
        <img src="/img/gastro-preview-img.png" alt="" />
        <div
          class="highlight-point"
          :class="`highlight-${getLocation(value)}`"
          v-for="(value, key) in findings"
          :key="'highlight'+value.id"
          v-if="getLocation(value) !== null"
        >
          <div class="highlight-inner-point">{{ key +1 }}</div>
        </div>
      </div>
      <ol class="pl-3" v-if="gastroFindings" >
        <li class="mb-2 font-weight-bold" v-for="(value, key) in findings" :key="key">
          {{ transI18n(value.name) }}
        </li>
      </ol>
    </div>
    <!-- <ul class="pl-3">
      <FindingsTypesLayout
        tag="li"
        :name="type"
        v-for="(value, type) in gastroFindings"
        :key="value.id"
      >
        <template #content>
          <template v-if="value.length">
            <li v-for="v in value" :key="v.id" class="mb-1">
              <FindingItemContent :finding="v" :images="getAllImages" />
            </li>
          </template>
          <p v-else>-</p>
        </template>
      </FindingsTypesLayout>
    </ul> -->
    <hr color="#B6BAC3" class="mb-2 mt-2" />
    <ul class="pl-3 mb-3" style="list-style: none;">
      <li v-for="(v, key) in findings" :key="v.id" class="mb-1">
        <FindingItemContent 
          :finding="v" 
          :index="key+1" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
          :locationNumbers="getLocation(v, true)"
        />
      </li>
      <li class="mb-1">
        <FindingOtherImages 
          :findings="findings" 
          :images="getAllImages" 
          :imgArrange="imgArrange" 
        />
      </li>
    </ul>
  </section>
</template>

<script>
import FindingsTypesLayout from '@/components/commons/FindingsTypesLayout.vue'
import FindingItemContent from '@/components/commons/FindingItemContent.vue'
import FindingOtherImages from '@/components/commons/FindingOtherImages.vue'
import GastroMixins from '@/components/commons/GastroMixins.js'
import {mapGetters, mapActions} from 'vuex'
import { findMatchI18n } from '@/utils/findMatchI18n'
import { getLocationByLesionsObservation } from '@/utils/finding'

export default {
  name: 'FindingInfoByOrgan',
  computed: {
    ...mapGetters('examinations', ['getExaminationData']),
    getAllImages() {
      if (this.getExaminationData && this.getExaminationData.all) {
        return this.getExaminationData.all.sort((a, b) => b.id - a.id)
      }
      return []
    },
  },
  components: {
    FindingItemContent,
    FindingsTypesLayout,
    FindingOtherImages
  },
  props: {
    findings: {
      type: Array,
      default: () => [],
    },
    imgArrange: {
      type: Number,
      default: 3
    }
  },
  mixins: [GastroMixins],
  data() {
    return {
      /*
       location=esophagus
      location=cervical esophagus
      location=upper esophagus
      location=middle esophagus
      location=lower esophagus
      location=cardia
      location=fundus
      location=body
      location=upper-body
      location=high-body
      location=mid-body
      location=low-body
      location=angle
      location=antrum
      location=bulb
      location=SDA
      location=2nd portion
      location=papilla
      location=ECJ
      */
      locationMap: {
        1: 'esophagus',
        2: 'cervical esophagus',
        3: 'upper esophagus',
        4: 'middle esophagus',
        5: 'lower esophagus',
        6: 'cardia',
        7: 'fundus',
        8: 'body',
        9: 'upper-body',
        10: 'high-body',
        11: 'mid-body',
        12: 'low-body',
        13: 'angle',
        14: 'antrum',
        15: 'bulb',
        16: 'sda',
        17: '2nd portion',
        18: 'papilla',
        19: 'ecj'
      }
    }
  },
  methods: {
    getLocation(finding, multiple = false) {
      return getLocationByLesionsObservation(finding, this.locationMap, multiple)
    },
    transI18n(text) {
      return findMatchI18n(text)
    }
  },
  mounted() {
    console.log(this.gastroFindings)
  }
}
</script>
<style lang="scss" scoped>
.highlight-area{
  display: grid;
  grid-template-columns: 410px 1fr;
}
.highlight-point{
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 50%;
  background-color: rgba(13, 148, 136, 0.3);
  align-items: center;
  justify-content: center;
  > .highlight-inner-point{
    width: 26px !important;
    height: 26px !important;
    display: inline-block;
    border-radius: 50%;
    color: #ffffff;
    background-color: rgb(13, 148, 136)
  }
  &.highlight-1, &.highlight-4{
    top: 220px;
    left: 185px;
  }
  &.highlight-2{
    top:154px;
    left:181px;
  }
  &.highlight-3{
    top:189px;
    left:180px;
  }
  &.highlight-5{
    top:252px;
    left:187px;
  }
  &.highlight-6{
    top:331px;
    left:200px;
  }
  &.highlight-7{
    top:306px;
    left:246px;
  }
  &.highlight-8, &.highlight-11{
    top:378px;
    left:243px;
  }
  &.highlight-9, &.highlight-10{
    top:344px;
    left:252px;
  }
  &.highlight-12{
    top:411px;
    left:221px;
  }
  &.highlight-13{
    top:385px;
    left:195px;
  }
  &.highlight-14{
    top:425px;
    left:195px;
  }
  &.highlight-15{
    top:390px;
    left:137px;
  }
  &.highlight-16, &.highlight-17, &.highlight-18{
    top:411px;
    left:129px;
  }
  &.highlight-19{
    top:294px;
    left:192px;
  }
}
</style>